import * as React from 'react';


function Button({children, callback}: {children: React.ReactNode, callback: () => any}): React.JSX.Element {
    return (
        <button type="button" onClick={callback}>{children}</button>
    );
}


export default Button;
